import React from 'react';
import ChartLiquidity from 'components/ChartLiquidity';

function LiquidationResults({ results }) {
   
    return (
        <>
            <div>
              <ChartLiquidity results={results} />
            </div>
        </>
    );
}

export default LiquidationResults;